import { JSONContent } from '@tiptap/core'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import { DraftConverter } from '@tiptap/draftjs-to-tiptap'

const removeEmptyTextNodes = (node: JSONContent) => {
  if (Array.isArray(node.content)) {
    node.content = node.content
      .map(removeEmptyTextNodes)
      .filter(child => !(child.type === 'text' && !child.text?.trim()))
  }
  return node
}

export const convertDraftToTiptap = (draftContent: string) => {
  const defaultConverter = new DraftConverter()
  const defaultMapEntityToMark = defaultConverter.options.mapEntityToMark
  const defaultMapInlineStyleToMark =
    defaultConverter.options.mapInlineStyleToMark

  try {
    const parsedDraft =
      typeof draftContent === 'string' ? JSON.parse(draftContent) : draftContent
    const draftConverter = new DraftConverter({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-expect-error
      mapEntityToMark: params => {
        const { range, entityMap, block } = params
        const entityKey = block.entityRanges[range.key]
        const entity = entityMap[entityKey.key]

        if (entity.type === 'LINK') {
          const data = entity.data
          return {
            type: 'link',
            attrs: {
              popupid: data.popupId,
              href: data.url || null,
              target: data.target,
              rel: data.rel,
            },
          }
        }

        return defaultMapEntityToMark?.(params) || null
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-expect-error
      mapInlineStyleToMark: params => {
        if (params.range.style.includes('rgba')) {
          return {
            type: 'textStyle',
            attrs: {
              color: params.range.style,
            },
          }
        }

        return defaultMapInlineStyleToMark?.(params) || null
      },
    })
    const result = draftConverter.convert(parsedDraft)

    return removeEmptyTextNodes(result)
  } catch {
    return ''
  }
}
